import * as THREE from 'three'
import Experience from '../Experience'

export default class Sofa {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.resources = this.experience.resources

    //options
    this.resource = this.experience.resources.items.sofa

    //methods
    this.setModel()
    this.setSofaMaterial()
  }

  setModel() {
    //add model with "scene"
    this.model = this.resource.scene
    this.model.scale.set(1.5, 1.5, 1.5)
    this.model.position.set(0, -2.5, 0)
    // this.model.rotation.x = Math.PI * 0.05

    this.scene.add(this.model)
  }
  setSofaMaterial() {
    /**
     * SOFA
     */
    //Sofa texture
    this.sofaTexture = this.experience.resources.items.bakedSofa
    this.sofaTexture.flipY = false
    this.sofaTexture.encoding = THREE.sRGBEncoding

    //Sofa material
    this.sofaMaterial = new THREE.MeshBasicMaterial({ map: this.sofaTexture })
    this.sofa = this.model.children.find(child => child.name === 'merged')
    this.sofa.material = this.sofaMaterial

    /**
     * TABLE
     */
    //table texture
    this.tableTexture = this.experience.resources.items.bakedTable
    this.tableTexture.flipY = false
    this.tableTexture.encoding = THREE.sRGBEncoding

    this.tableMaterial = new THREE.MeshBasicMaterial({ map: this.tableTexture })
    this.table = this.model.children.find(child => child.name === 'table')
    this.pot = this.model.children.find(child => child.name === 'pot')

    this.table.material = this.tableMaterial
    this.pot.material = this.tableMaterial

    //Paper
    this.paperTexture = this.experience.resources.items.uxImage
    this.paperTexture.flipY = false
    this.paperTexture.encoding = THREE.sRGBEncoding
    this.paperMaterial = new THREE.MeshBasicMaterial({ map: this.paperTexture })
    this.paper = this.model.children.find(child => child.name === 'paper')
    this.paper.material = this.paperMaterial

    /**
     * RUG
     */
    //rugtexture
    this.rugTexture = this.experience.resources.items.bakedRug
    this.rugTexture.flipY = false
    this.rugTexture.encoding = THREE.sRGBEncoding

    this.rugMaterial = new THREE.MeshBasicMaterial({ map: this.rugTexture })
    this.rug = this.model.children.find(child => child.name === 'rug')
    this.rug.material = this.rugMaterial
  }
}
